import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { reviews, faqs } from '@/mocks/comics';

export default function AboutPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <>
      <Navbar />
      <main className="pt-20 pb-14 bg-background-50">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <nav className="flex items-center gap-2 text-xs text-foreground-500 mb-8">
            <a href="/" className="hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">首页</a>
            <span className="text-foreground-300">/</span>
            <span className="text-foreground-700 font-medium">关于我们</span>
          </nav>

          <section className="mb-14">
            <h1 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-6">关于虫虫漫画网</h1>
            <div className="bg-background-100 rounded-lg p-6 md:p-8">
              <h2 className="text-lg font-heading text-foreground-900 mb-4">品牌介绍</h2>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                虫虫漫画网成立于2024年，是国内领先的下拉式完整版免费漫画阅读平台。我们专注于为中文读者提供高质量的韩国漫画阅读体验，
                坚持"免费、完整、流畅"的服务理念，让每一位漫画爱好者都能享受到最纯粹的阅读乐趣。
              </p>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                虫虫漫画网主打<strong>下拉式完整版免费阅读</strong>，平台上的所有韩国漫画资源均为<strong>无删减</strong>版本，
                读者只需<strong>下拉观看</strong>即可流畅阅读，无需翻页点击，操作便捷体验出色。
                我们拥有超过500部各类精彩韩国漫画，涵盖恋爱言情、奇幻冒险、动作热血、悬疑推理、搞笑日常、耽美BL、恐怖惊悚等八大分类频道。
              </p>
              <p className="text-sm text-foreground-700 leading-relaxed">
                虫虫漫画网团队由一群热爱漫画的年轻人组成，我们深知漫画读者的需求——不仅要看到完整的剧情，
                更要享受流畅的阅读过程。因此我们不断优化网站性能，确保下拉观看流畅不卡顿，
                让每一位来到虫虫漫画网的读者都能获得最佳的阅读体验。
              </p>
            </div>
          </section>

          <section className="mb-14">
            <h2 className="text-xl font-heading text-foreground-900 mb-6">用户口碑</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {reviews.map((review) => (
                <div key={review.id} className="bg-background-100 rounded-lg p-5">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                      <span className="text-sm font-semibold text-primary-700">
                        {review.username.charAt(0)}
                      </span>
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">{review.username}</p>
                      <div className="flex items-center gap-0.5 mt-0.5">
                        {Array.from({ length: review.rating }).map((_, i) => (
                          <div key={i} className="w-3.5 h-3.5 flex items-center justify-center">
                            <i className="ri-star-fill text-xs text-accent-500"></i>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed">{review.content}</p>
                  <p className="text-xs text-foreground-400 mt-2">{review.date}</p>
                </div>
              ))}
            </div>
          </section>

          <section className="mb-14">
            <h2 className="text-xl font-heading text-foreground-900 mb-6">联系我们</h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <div className="bg-background-100 rounded-lg p-6">
                <h3 className="text-base font-heading text-foreground-900 mb-4">联系方式</h3>
                <div className="space-y-3">
                  <div className="flex items-center gap-3 text-sm text-foreground-700">
                    <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                      <i className="ri-mail-line text-primary-600"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500">电子邮箱</p>
                      <p>contact@chongchongmanhua.com</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3 text-sm text-foreground-700">
                    <div className="w-9 h-9 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0">
                      <i className="ri-customer-service-line text-accent-600"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500">在线客服</p>
                      <p>周一至周日 9:00 - 22:00</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3 text-sm text-foreground-700">
                    <div className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-100 flex-shrink-0">
                      <i className="ri-map-pin-line text-secondary-600"></i>
                    </div>
                    <div>
                      <p className="text-xs text-foreground-500">办公地址</p>
                      <p>北京市朝阳区望京科技园</p>
                    </div>
                  </div>
                </div>
                <div className="flex gap-3 mt-5">
                  <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 hover:bg-primary-100 transition-colors cursor-pointer" aria-label="微博">
                    <i className="ri-weibo-line text-foreground-600"></i>
                  </a>
                  <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 hover:bg-primary-100 transition-colors cursor-pointer" aria-label="微信">
                    <i className="ri-wechat-line text-foreground-600"></i>
                  </a>
                  <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 hover:bg-primary-100 transition-colors cursor-pointer" aria-label="QQ">
                    <i className="ri-qq-line text-foreground-600"></i>
                  </a>
                </div>
              </div>

              <div className="bg-background-100 rounded-lg p-6">
                <h3 className="text-base font-heading text-foreground-900 mb-4">发送消息</h3>
                <form
                  data-readdy-form
                  action="https://readdy.ai/api/form/d9peod1n2trhb35gve3g"
                  method="POST"
                  className="space-y-4"
                  onSubmit={async (e) => {
                    e.preventDefault();
                    const form = e.currentTarget;
                    const honeypot = (form.querySelector('[name="website_alt"]') as HTMLInputElement)?.value?.trim();
                    if (honeypot) {
                      const msgEl = document.getElementById('contact-form-msg');
                      if (msgEl) {
                        msgEl.textContent = '消息已发送，我们会尽快回复！';
                        msgEl.className = 'text-xs text-green-600 mt-2';
                      }
                      form.reset();
                      return;
                    }
                    try {
                      const res = await fetch(form.action, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                        body: new URLSearchParams(new FormData(form) as unknown as Record<string, string>).toString(),
                      });
                      const responseText = await res.text();
                      const msgEl = document.getElementById('contact-form-msg');
                      if (!msgEl) return;
                      let parsed;
                      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
                      const serverMsg = parsed?.meta?.message || parsed?.message || '';
                      if (res.ok && parsed?.code === 'OK') {
                        msgEl.textContent = '消息已发送，我们会尽快回复！';
                        msgEl.className = 'text-xs text-green-600 mt-2';
                        form.reset();
                      } else {
                        const errorMsg = serverMsg || '发送失败，请稍后重试。';
                        msgEl.textContent = errorMsg;
                        msgEl.className = 'text-xs text-red-500 mt-2';
                      }
                    } catch {
                      const msgEl = document.getElementById('contact-form-msg');
                      if (msgEl) {
                        msgEl.textContent = '网络错误，请稍后重试。';
                        msgEl.className = 'text-xs text-red-500 mt-2';
                      }
                    }
                  }}
                >
                  <div>
                    <label htmlFor="contact-name" className="block text-xs text-foreground-600 mb-1">姓名</label>
                    <input
                      id="contact-name"
                      name="name"
                      type="text"
                      required
                      className="w-full px-4 py-2.5 text-sm rounded-lg bg-background-50 border border-background-200/70 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-email" className="block text-xs text-foreground-600 mb-1">邮箱</label>
                    <input
                      id="contact-email"
                      name="email"
                      type="email"
                      required
                      className="w-full px-4 py-2.5 text-sm rounded-lg bg-background-50 border border-background-200/70 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact-message" className="block text-xs text-foreground-600 mb-1">消息</label>
                    <textarea
                      id="contact-message"
                      name="message"
                      required
                      maxLength={500}
                      rows={4}
                      className="w-full px-4 py-2.5 text-sm rounded-lg bg-background-50 border border-background-200/70 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all resize-none"
                      placeholder="请输入您的消息（最多500字）"
                    ></textarea>
                  </div>
                  <input
                    type="text"
                    name="website_alt"
                    tabIndex={-1}
                    autoComplete="off"
                    aria-hidden="true"
                    readOnly
                    className="website-alt-field"
                  />
                  <button
                    type="submit"
                    className="w-full px-6 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    发送消息
                  </button>
                  <div id="contact-form-msg"></div>
                </form>
              </div>
            </div>
          </section>

          <section className="mb-14">
            <h2 className="text-xl font-heading text-foreground-900 mb-6">常见问题</h2>
            <div className="space-y-3">
              {faqs.map((faq, idx) => (
                <details key={idx} className="bg-background-100 rounded-lg group">
                  <summary className="px-5 py-4 cursor-pointer flex items-center justify-between text-sm font-medium text-foreground-900">
                    {faq.question}
                    <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 ml-3">
                      <i className="ri-arrow-down-s-line group-open:rotate-180 transition-transform"></i>
                    </div>
                  </summary>
                  <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </div>
                </details>
              ))}
            </div>
          </section>
        </div>
      </main>
      <Footer />
      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'AboutPage',
          'name': '关于虫虫漫画网',
          'description': '虫虫漫画网是领先的下拉式完整版免费漫画阅读平台，提供海量无删减韩国漫画资源。',
          'url': 'https://www.chongchongmanhua.com/about',
          'breadcrumb': {
            '@type': 'BreadcrumbList',
            'itemListElement': [
              { '@type': 'ListItem', 'position': 1, 'name': '首页', 'item': 'https://www.chongchongmanhua.com/' },
              { '@type': 'ListItem', 'position': 2, 'name': '关于我们', 'item': 'https://www.chongchongmanhua.com/about' }
            ]
          },
          'mainEntity': {
            '@type': 'FAQPage',
            'mainEntity': faqs.map((faq) => ({
              '@type': 'Question',
              'name': faq.question,
              'acceptedAnswer': {
                '@type': 'Answer',
                'text': faq.answer
              }
            }))
          }
        })
      }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          'name': '虫虫漫画网',
          'url': 'https://www.chongchongmanhua.com/',
          'description': '虫虫漫画网主打下拉式完整版免费阅读，提供海量无删减韩国漫画资源。',
          'email': 'contact@chongchongmanhua.com',
          'address': { '@type': 'PostalAddress', 'addressLocality': '北京', 'addressCountry': 'CN' },
          'contactPoint': {
            '@type': 'ContactPoint',
            'contactType': 'customer service',
            'availableLanguage': ['Chinese']
          }
        })
      }} />
    </>
  );
}